import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { clearKeycloakLoginRedirect, keycloakLogin } from './keycloak-login-redirect';

@Injectable({
    providedIn: 'root',
})
export class AuthGuardService extends KeycloakAuthGuard {
    constructor(protected readonly router: Router, protected readonly keycloakService: KeycloakService) {
        super(router, keycloakService);
    }

    async isAccessAllowed(): Promise<boolean> {
        const loggedIn = await this.keycloakService.isLoggedIn();
        if (loggedIn) {
            clearKeycloakLoginRedirect();
        }
        if (!loggedIn) {
            console.log('User is not authenticated. Redirecting to login...');
            await keycloakLogin(this.keycloakService);
        }
        return loggedIn;
    }

}
